import styled from "styled-components";
import { Title, Body, FormItem as Fi } from "sunday-component";
import { Image, Modal as M, Row } from "antd";
import { color } from "src/styles/globals";
import { CheckOutlined as Cl } from "@ant-design/icons";
import { down } from "styled-breakpoints";
import LinkTitle from "../Common/LinkTitle";
import CommonForm from "../Common/Form/Form";
import Button from "../Common/Button";
import ErrorDialog from "../Common/ErrorDialog";

const maxContentWidth = "343px";

export const CheckOutlined = styled(Cl)`
  color: #1c7c4e;
  font-weight: bold;
  font-size: 17px;
  line-height: 18px;
`;

export const Verified = styled(Title).attrs({ level: 9 })`
  margin-left: 10px;
  color: #1c7c4e;
`;

export const SubmitButton = styled(Button)`
  max-height: 48px;
  width: 100%;
  padding: 0px;
`;

export const Form = styled(CommonForm)`
  .sunday-component-form-item {
    margin: 0px;
    height: auto;
  }
  ${down("lg")} {
    max-width: ${maxContentWidth};
    margin: 0 auto;
  }
`;

export const FormItem = styled(Fi)`
  margin: 0px;
`;

export const OtpFormItem = styled(Fi)`
  margin: 0px;
`;

export const LoginModal = styled(M)`
  max-width: 444px;
  .ant-modal-content {
    border-radius: 16px;
    overflow: hidden;
  }
  .ant-modal-close {
    margin-top: 8px;
  }
  .ant-modal-header {
  }
  .ant-modal-body {
    padding: 16px;
  }
  .ant-modal-footer {
    padding: 16px;
  }
  ${down("lg")} {
    top: 0;
    margin: 0px;
    padding: 0px;
    .ant-modal,
    .ant-modal-content {
      height: 100vh;
      width: 100vw;
      margin: 0;
      top: 0;
    }
    .ant-modal-footer {
      position: fixed;
      bottom: 0;
      width: 100%;
      background: white;
    }
    .ant-modal-content {
      border-radius: 0px;
    }
    .ant-modal-body {
      overflow: auto;
      padding-top: 16px;
      padding-bottom: 24px;
      height: calc(100vh - 60px);
    }
  }
`;

export const LoginModalContent = styled.div``;

export const ModalTitle = styled(Title).attrs({ level: 5 })`
  position: relative;
  text-align: center;
  color: ${color.charcoal10};
`;

export const ModalCloseIcon = styled.div`
  position: absolute;
  display: flex;
  items: center;
  width: 24px;
  height: 100%;
  right: 0;
  top: 0;
`;

export const CloseIcon = styled(Image)`
  cursor: pointer;
`;

export const LoginModalBody = styled(Body).attrs({ level: 7 })`
  color: ${color.charcoal09};
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  ${down("lg")} {
    max-width: ${maxContentWidth};
    margin: 0 auto;
  }
`;

export const ButtonTitle = styled(Title).attrs({ level: 7 })``;

export const ResendButton = styled(LinkTitle).attrs({ level: 7 })`
  margin-top: 4px;
  cursor: pointer;
`;

export const ResendWait = styled(Title).attrs({ level: 7 })`
  color: ${color.charcoal09};
  margin-top: 4px;
`;

export const CancelModal = styled(M)`
  max-width: 444px;
  .ant-modal-content {
    border-radius: 16px;
    overflow: hidden;
  }
  .ant-modal-close {
    margin-top: 8px;
  }
  .ant-modal-header {
    display: flex;
    justify-content: center;
  }
  .ant-modal-body {
    text-align: center;
    padding: 16px;
  }
  .ant-modal-footer {
    display: flex;
    flex-direction: column;
    row-gap: 8px;
  }
  ${down("md")} {
    max-width: 300px;
    .ant-modal-title {
      max-width: 200px;
    }
  }
`;

export const CancelModalBody = styled(Body).attrs({ level: 7 })`
  color: ${color.charcoal09};
`;

export const WelcomeModal = styled(M)`
  max-width: 444px;
  .ant-modal-content {
    border-radius: 16px;
    overflow: hidden;
  }
  .ant-modal-header {
  }
  .ant-modal-body {
    padding: 0px;
    text-align: center;
  }
  .ant-modal-footer {
    display: flex;
    flex-direction: column;
    row-gap: 8px;
  }
  .ant-image {
    bottom: 4px;
  }
  ${down("md")} {
    max-width: 300px;
    .ant-image {
      bottom: 2px;
    }
  }
`;

export const WelcomeModalBody = styled(Body).attrs({ level: 7 })`
  padding: 16px;
  color: ${color.charcoal09};
`;

export const WelcomeBanner = styled(Row)`
  align-items: end;
  justify-content: center;
  background-image: url("/static/pages/registerOtp/register-welcome-bg.svg");
  background-repeat: no-repeat;
  background-size: cover;
  height: 250px;
  border-radius: 0% 0% 100% 100% / 0% 0% 20% 20%;
  overflow: hidden;
  ${down("md")} {
    height: 155px;
  }
`;

export const WelcomeBannerImage = styled(Image)`
  display: block;
  max-height: 205px;
  border-radius: 0% 0% 100% 100% / 0% 0% 10% 10%;
  ${down("md")} {
    max-height: 134px;
    border-radius: 0% 0% 100% 100% / 0% 0% 5% 5%;
  }
`;

export const ErrorModal = styled(ErrorDialog)``;

export const ErrorModalBody = styled(Body).attrs({ level: 7 })`
  margin-top: 8px;
  color: ${color.charcoal09};
  text-align: center;
`;
